import Vue from 'vue'
import Vuetify from 'vuetify/lib'
import 'vuetify/src/stylus/app.styl'

Vue.use(Vuetify, {
  theme: {
    primary: '#3966FF',
    secondary: '#19355E',
    third: '#219EBC',
    error: '#FF5252',
    info: '#2196F3',
    success: '#4CAF50',
    warning: '#ffb703',
    grey: '#c2c1c1'
  },
  iconfont: 'md',
})
